import { BASE_HOST, globalData } from './config';
import { PLAN_OBJ } from './type';
import axios from 'axios';
import qs from 'qs';
import moment from 'moment';
import AddressSplit from '../utils/addreeSplit';
import ExpressAddressSplit from '../utils/expressAddressSplit';
import getIdCardInfo from '../utils/getFullAge';
import { getOptionalAttributeValueArr } from '../utils/getDutyList';
import _ from 'lodash';

let YiJianXianList = ['P060027', 'P060038', 'P060039'];
// 获取行业数据
export const getTradeInfo = (data) => axios.request({
  method: 'get',
  params: data,
  url: BASE_HOST + '/pa18shopnst/do/micro/getMicroNormalProductIndustry',
});
// 赔偿能力
export const getPDF = () => axios.request({
  method: 'get',
  params: {
    flowId: globalData['flowId'],
  },
  url: BASE_HOST + '/pa18shopnst/do/apply/queryProductTermFiles',
});

// 获取条款pdf
export const getPDFForAli = (params) => axios.request({
  method: 'POST',
  data: {
    flowId: globalData['flowId'],
    planCodes: params.planCodes,
  },
  url: BASE_HOST + '/pa18shopnst/do/apply/queryProductTermFilesForAli',
});

// 赔偿能力
export const querySolvencyInfo = () => axios.request({
  method: 'get',
  url: BASE_HOST + '/pa18shopnst/do/common/querySolvencyInfo',
});

// 退出登录
export const loginOut = (param: string) => axios.request({
  method: 'POST',
  data: param,
  url: BASE_HOST + '/pa18shopnst/request/onepingan/logout?key=lk',
});

// 查询用户信息
export const queryUser = () => axios.request({
  method: 'get',
  params: {
    isQueryUser: true,
    _: (new Date()).valueOf(),
  },
  url: BASE_HOST + '/pa18shopnst/do/era/member/queryUser',
});


// 查询保单接口
export const showPolicy = () => {
  let params = Object.assign({}, globalData['gUrlData']);
  // url中有ITS参数表示是从电销过来的保单查询 则使用 online/showPolicy/new 否则则是保险商城过来的保单查询 使用policy/showPolicy/jspToJson
  const sUrl = globalData['gUrlData']['isITS'] ? '/pa18shopnst/do/online/showPolicy/new' : '/pa18shopnst/do/policy/showPolicy/jspToJson';
  return axios.request({
    method: 'get',
    params,
    url: BASE_HOST + sUrl,
  });
};

// 确认支付状态
export const checkPay = (orderNo: string) => axios.request({
  method: 'get',
  params: {
    orderNo,
  },
  url: BASE_HOST + '/pa18shopnst/do/policy/checkPay.do',
});

// 保持流程接口
export const keepFlow = () => axios.request({
  method: 'get',
  params: {
    flowId: globalData['flowId'],
  },
  url: BASE_HOST + '/pa18shopnst/do/keep-flow-ctx.do',
});


// 企业证件号接口
export const checkGroupOrganization = (code: string) => axios.request({
  method: 'post',
  data: {
    orgCodeNo: code,
  },
  url: BASE_HOST + '/pa18shopnst/do/apply/microCompany/checkGroupOrganization',
});

// 企业证件号接口-小微产品
export const checkGroupOrganizationForMicro = (code: string) => axios.request({
  method: 'post',
  data: {
    orgCodeNo: code,
    flowId: globalData['flowId'],
  },
  url: BASE_HOST + '/pa18shopnst/do/micro/query/tradeFromEbcs',
});

// 校验黑名单 resultCode:00成功 01失败
export const quiryBlackVerify = (params: object) => axios.request({
  method: 'post',
  data: params,
  url: BASE_HOST + '/pa18shopnst/do/mciro/commonen/quiryBlackVerify',
});

// 核保接口
export const applyPolicy = () => axios.request({
  method: 'get',
  params: {
    flowId: globalData['flowId'],
  },
  url: BASE_HOST + '/pa18shopnst/do/era/apply/applyPolicy',
});

// 获取日期接口
export const getPeriod = (beginDate?: string, termUnit?: string, term?: number) => {
  // 带beginDate参数时返回计算后的投保日期
  if (beginDate) {
    return axios.request({
      method: 'POST',
      data: qs.stringify({
        flowId: globalData['flowId'],
        termUnit: termUnit || 'M',
        term: term || 12,
        beginDate,
      }),
      url: BASE_HOST + '/pa18shopnst/do/era/period/getPeriod',
    });
  }
  // 取当前流程号中的投保日期
  return axios.request({
    method: 'get',
    params: {
      flowId: globalData['flowId'],
    },
    url: BASE_HOST + '/pa18shopnst/do/era/period/getPeriod',
  });
};

// 获取职业接口
export const getProfession = (type?: number) => {
  const { productCode, teamAccidentProds } = globalData;
  // 是否是团意产品
  const isTeamAccidentProd = teamAccidentProds.includes(productCode);
  if (isTeamAccidentProd) {
    return axios.request({
      method: 'get',
      params: {},
      url: BASE_HOST + '/pa18shopnst/do/group/getAhsProfessionInfoList',
    });
  } else {
    let params = {
      productCode: globalData['productCode']
    }
    if (type) {
      params['professionType'] = type;
    }
    return axios.request({
      method: 'get',
      params: params,
      url: BASE_HOST + '/pa18shopnst/do/apply/mic/profession',
    });
  }
};

/**
 * 获取地址信息
 * @param {number} currentCode - 当前代码
 * @param {string} p_code - 父级地区代码
 * @returns {void}
 */
export const getAddress = (currentCode: number, p_code: string) => axios.request({
  method: 'post',
  params: {
    currentCode, // 当前地区code
    p_code, // 父级地区code
  },
  url: BASE_HOST + '/pa18shopnst/do/query/getAddress',
});

/**
 * 获取省份和城市信息
 * @returns {void}
 */
export const eraGetProvinceCity = () => axios.request({
  method: 'get',
  params: {
    productCode: globalData['productCode'],
    microFlag: 'Y', // 小微的产品标示
    flowId: globalData['flowId'],
  },
  url: BASE_HOST + '/pa18shopnst/do/apply/getAllDistrict',
});

/**
 * 产品初始化
 * @param {string} productCode - 产品代码
 * @returns {void}
 */
export const applyInit = (productCode: string) => {
  let params = Object.assign({ productCode }, globalData['gUrlData']);
  return axios.request({
    method: 'get',
    params,
    url: BASE_HOST + '/pa18shopnst/do/era/init/applyInit',
  });
};

/**
 * 获取产品信息
 * @param {object} params - 请求参数
 * @returns {void}
 */
export const getProductInfo = (params: object) => {
  const commonParams = {
    productCode: globalData['productCode'], // 产品编码
    flowId: globalData['flowId'], // 流程号
    channelAuthorizeCode: 6,
    industryType1: 'I',
    industryType2: 'I67',
    industryType3: 'I671',
    industryType4: 'I6710',
  };
  let url = BASE_HOST + '/pa18shopnst/do/micro/getProductInfo';
  const { productCode, teamAccidentProds } = globalData;
  // 是否是团意产品
  const isTeamAccidentProd = teamAccidentProds.includes(productCode);
  if (isTeamAccidentProd) {
    url = BASE_HOST + '/pa18shopnst/do/group/getProductInfo';
  }
  return axios.request({
    method: 'post',
    data: qs.stringify(Object.assign(commonParams, params)),
    url,
  });
};

/**
 * 获取阿里产品的初始价格
 * @param params - 包含获取价格的参数
 */
export const getAliProductOriginPrice = (params: any) => axios.request({
  method: 'post',
  params: {
    personNum: params.personNum,
    packageCode: params.packageCode, // 父级地区code
  },
  url: BASE_HOST + '/pa18shopnst/do/mciro/commonen/queryPackagePremiun',
});

/**
 * 校验企业名称是否可以投保（是否领取过赠险，且当前applyNo未使用过
 * @param params - 查询参数
 */
export const queryGiftPolicyByUsciCodeApi = (params: any) => axios.request({
  method: 'post',
  params: {
    flowId: params.flowId,
    groupName: params.groupName,
    productCode: params.giftProductCode,
    applyNo: params.applyNo
  },
  url: BASE_HOST + '/pa18shopnst/do/mciro/commonen/queryGiftPolicyByUsciCode',
});

/**
 * 团意产品 获取行业信息
 * @param params - 查询参数
 */
export const getIndustryListForTeamProdApi = (params: any) => axios.request({
  method: 'get',
  params,
  url: BASE_HOST + '/pa18shopnst/do/group/getAhsIndustries',
});

/**
 * 通用报价函数
 * @param {object} formData - 表单数据
 * @returns {Promise<number>} - 返回报价结果的Promise对象
 */
export const commonQuote = (formData: object): Promise<number> => {
  const { productCode, aliProductCodes, teamAccidentProds } = globalData;
  const isAliProduct = aliProductCodes.includes(productCode);
  // 是否是团意产品
  const isTeamAccidentProd = teamAccidentProds.includes(productCode);
  const addressArr = isAliProduct ? formData['enterprise']['groupAddressInfo'] : formData['entreAddress'];
  const address = AddressSplit(addressArr); // 企业地址
  const appProductInfo = globalData['appProductInfo']; // 产品信息
  const addDays = appProductInfo['insurancePeriodInfo'] && appProductInfo['insurancePeriodInfo'].shortestEffectiveTime ? appProductInfo['insurancePeriodInfo'].shortestEffectiveTime : 1;
  const planInfo = globalData['planInfo']; // 产品的planInfo
  const selectedSet = globalData['selectedSet']; // 当前选择的套餐
  const currentTableData = formData['table'][selectedSet];
  const packageCode = appProductInfo['packageList'][selectedSet]['packageCode']; // 当前套餐的packageCode
  const personnelListKeyName = isTeamAccidentProd ? 'personnelList' : (appProductInfo['packageList'][selectedSet]['personnelType'] === '03' ? 'acplPersonnelList' : 'personnelList');
  const riskGroupNameList = ['一类职业', '二类职业', '三类职业', '四类职业', '五类职业', '六类职业']; // 职业类型
  const riskGroupWorkTypeList = ['61', '62', '63', '64', '65', '66']; // 职业类型对应的worktype
  let sumPerson = 0,
    riskGroupType = 0;
  let planDuty: any[] = [];
  let relationDutyCodeObj = {};
  let riskGroupInfoList: any = [];
  let needPlanDuty = ['P060030', 'P060038', 'P060039']; // 意健险 上传 microQuoteForm.riskPropertyInfoList节点
  // 没有雇员或者意健险
  let isNoStaff = ['P060031', 'P060032', 'P060033', 'P060035', 'P060036', 'P060037'].includes(productCode);
  isNoStaff = !formData['riskGroup' + selectedSet];
  // 处理每个职业类型的数据 （所有投保值为0的职业,PL,CV都不返回给后端）
  if (isNoStaff) {
    riskGroupInfoList = [];
    // 没有雇主责任险的险种
    if (productCode === "P060090") {
      let planInfoList: any[] = [];
      let tableData = formData['table'][selectedSet];
      Object.keys(tableData).map((plan, planIndex) => {
        const dutyList = formData['table'][selectedSet][plan];
        let totalInsuredAmount = 0;
        let dutyInfoListItem: any[] = [];
        let totalInsuredAmountEvery = 0;
        // 其他PL取保单中的投保值
        for (const duty of globalData['dutyList']) {
          const dutyAmount = (duty['amountArangeMap'] || {})['amount'];
          relationDutyCodeObj[duty.dutyCode] = duty.relationDutyCode;
          totalInsuredAmount = totalInsuredAmount + Number(dutyAmount);

          if (dutyList === -2) {
            dutyInfoListItem.push({
              dutyCode: duty['dutyCode'],
              insuredAmount: Number(dutyAmount),
            });
          } else {
            if (totalInsuredAmount == 0 && dutyList == 0) {
              dutyInfoListItem.push({
                dutyCode: duty['dutyCode'],
                insuredAmount: Number(dutyAmount),
              });
            }
          }
        }
        Object.keys(dutyList).map((duty: string, dutyIndex) => {
          // 当前的责任信息
          const currentDutyInfo = (globalData['dutyList'] || []).find((dutyInfo) => /^CV/.test(duty) && dutyInfo.dutyCode === duty) || {};
          let indexKey = selectedSet;
          let dutyAmount = typeof dutyList[duty] === 'object' ? dutyList[duty][indexKey] : dutyList[duty];

          if (/^CV/.test(duty)) {
            let currentAmount = Number(dutyAmount) === -1 ? 0 : Number(dutyAmount);
            totalInsuredAmount = totalInsuredAmount + currentAmount; // 此处是原本的逻辑，没明白，保持不动
            totalInsuredAmountEvery = totalInsuredAmountEvery + currentAmount;
          }

          // 过滤数据：只需要传入dutyAttrAmountValue、dutyAttrCode、dutyAttributeName这三个参数就可以了
          let currentDutyAttributeInfoList = (currentDutyInfo.dutyAttributeInfoList || []).map((attr) => ({
            dutyAttrAmountValue: attr.dutyAttrAmountValue,
            dutyAttrCode: attr.dutyAttrCode,
            dutyAttributeName: attr.dutyAttributeName,
          }));

          let obj = {
            dutyCode: duty,
            dutyName: currentDutyInfo['dutyChineseName'],
            insuredAmount: !/^CV/.test(duty) ? dutyAmount : Number(dutyAmount),
            dutyAttributeInfoList: currentDutyAttributeInfoList
          };

          if (Number(dutyAmount) >= 0) { // 投保额可以为0，投保额为0也要返回给后端，过滤掉-1(不承保)
            dutyInfoListItem.push(obj);
          }
          return dutyIndex;
        });

        // 所有投保值为0的职业,PL,CV都不返回给后端
        if (dutyInfoListItem.length > 0 && /^PL[\d|A-Z]+$/.test(plan)) {
          let planObj: PLAN_OBJ = {
            planName: planInfo[plan].planChineseName,
            isMain: planInfo[plan]['isMain'],
            planCode: plan,
            totalInsuredAmount: totalInsuredAmountEvery,
            dutyInfoList: dutyInfoListItem,
          };
          planInfoList.push(planObj);
        }
        return planIndex;
      });
      
      riskGroupInfoList = [{
        applyNum: 1,
        applyRiskNum: 1,
        planInfoList: planInfoList,
        productPackageType: packageCode,
        riskPropertyInfoList: [
          { employerInsuranceNum: 0 },
        ],
      }];
    } else {
      try {
        let tableData = formData['table'][selectedSet];
        for (let plCode in tableData) {
          let cvCodeObj = tableData[plCode];
          for (let cvCode in cvCodeObj) {
            if (cvCodeObj[cvCode] > 0) {
              if (globalData['productCode'] === 'P060031' || globalData['productCode'] === 'P060032' || globalData['productCode'] === 'P060033') {
                const currentDutyInfo = (globalData['dutyList'] || []).find((dutyInfo) => /^CV/.test(cvCode) && dutyInfo.dutyCode === cvCode) || {};
                // 先把relationDutyCode的保额变成当前选中的保额
                let currentDutyAttributeIndex = 0;
                let currentDutyAttributeInfoList = (currentDutyInfo.dutyAttributeInfoList || []).map((attr) => {
                  let newAttr = _.cloneDeep(attr);
                  if (newAttr.dutyAttrCode === currentDutyInfo.relationDutyCode) {
                    newAttr.dutyAttrAmountValue = cvCodeObj[cvCode];
                    currentDutyAttributeIndex = (newAttr.optionalAttributeValue || '').split(',').findIndex(item => item * 1 === newAttr.dutyAttrAmountValue * 1);
                  }
                  return newAttr;
                });
                // 需要展示的其他关联属性的保额也随之联动
                currentDutyAttributeInfoList = currentDutyAttributeInfoList.map(attr => {
                  let newAttr = _.cloneDeep(attr);
                  if (newAttr.dutyAttrCode !== currentDutyInfo.relationDutyCode && newAttr.showFlag === '1') {
                    let tempAttributeArr = (newAttr.optionalAttributeValue || '').split(',');
                    if (tempAttributeArr.length > 0) {
                      newAttr.dutyAttrAmountValue = tempAttributeArr[currentDutyAttributeIndex] || tempAttributeArr[tempAttributeArr.length - 1]
                    }
                  }
                  return newAttr
                })
                // 过滤数据：只需要传入dutyAttrAmountValue、dutyAttrCode、dutyAttributeName这三个参数就可以了
                currentDutyAttributeInfoList = currentDutyAttributeInfoList.map((attr) => ({
                  dutyAttrAmountValue: attr.dutyAttrAmountValue,
                  dutyAttrCode: attr.dutyAttrCode,
                  dutyAttributeName: attr.dutyAttributeName,
                }));
                planDuty.push({
                  planCode: plCode,
                  dutyCode: cvCode,
                  subjectType: '02',
                  value: cvCodeObj[cvCode],
                  dutyAttributeInfoList: currentDutyAttributeInfoList
                });
              } else {
                planDuty.push({
                  planCode: plCode,
                  dutyCode: cvCode,
                  subjectType: '02',
                  value: cvCodeObj[cvCode]
                });
              }
            }
          }
        }
      } catch (e) {
        console.error('获取planDuty失败:', e);
      }
    }
  } else {
    riskGroupInfoList = formData['riskGroup' + selectedSet].map((item, riskIndex) => {
      if (!Number(item)) {
        return;
      }
      riskGroupType++; // 从1开始递增 不考虑职业类型
      sumPerson = sumPerson + Number(item);
      let planInfoList: any[] = [];
      let tableData = formData['table'][selectedSet];
      if (needPlanDuty.includes(globalData['productCode'])) {
        for (let plan in tableData) {
          let dutyInfo = Object.keys(tableData[plan]);
          dutyInfo.forEach((info) => {
            tableData[plan][info] > 0 && planDuty.push({
              planCode: plan,
              dutyCode: info,
              subjectType: '02',
              value: tableData[plan][info],
            });
          });
          const needDutyCodes = globalData['dutyList'].map((duty) => duty.dutyCode);
          planDuty = planDuty.filter((plan) => needDutyCodes.includes(plan.dutyCode));
        }
      }
      // 处理每个职业类型下的PL数据
      Object.keys(formData['table'][selectedSet]).map((plan, planIndex) => {
        const dutyList = formData['table'][selectedSet][plan];
        let totalInsuredAmount = 0,
          dutyInfoListItem: any[] = []; let totalInsuredAmountEvery = 0;
        // PL0700604 和 PL0700605 因为不区分责任所以选择投保时取其productInfo中的默认值
        if (plan === 'PL0700604' || plan === 'PL0700605') {
          for (const duty of globalData['dutyList']) {
            if (duty['planCode'] === plan && dutyList === 1) {
              const dutyAmount = (duty['amountArangeMap'] || {})['amount'];
              totalInsuredAmount = totalInsuredAmount + Number(dutyAmount);
              dutyInfoListItem.push({
                dutyCode: duty['dutyCode'],
                insuredAmount: Number(dutyAmount),
              });
            } else if (duty['planCode'] === plan && (dutyList != 1 && dutyList != -1)) { // 选择承保  是否隐藏功能+ 单独设置
              const dutyAmount = (duty['amountArangeMap'] || {})['amount'];
              totalInsuredAmount = totalInsuredAmount + Number(dutyAmount);
              dutyInfoListItem.push({
                dutyCode: duty['dutyCode'],
                insuredAmount: Number(dutyAmount),
              });
            }
          }
        } else {
          // 其他PL取保单中的投保值
          for (const duty of globalData['dutyList']) {
            const dutyAmount = (duty['amountArangeMap'] || {})['amount'];
            relationDutyCodeObj[duty.dutyCode] = duty.relationDutyCode;
            totalInsuredAmount = totalInsuredAmount + Number(dutyAmount);

            if (dutyList === -2) {
              dutyInfoListItem.push({
                dutyCode: duty['dutyCode'],
                insuredAmount: Number(dutyAmount),
              });
            } else {
              if (totalInsuredAmount == 0 && dutyList == 0) {
                dutyInfoListItem.push({
                  dutyCode: duty['dutyCode'],
                  insuredAmount: Number(dutyAmount),
                });
              }
            }
          }
          Object.keys(dutyList).map((duty: string, dutyIndex) => {

            // 当前的责任信息
            const currentDutyInfo = (globalData['dutyList'] || []).find((dutyInfo) => /^CV/.test(duty) && dutyInfo.dutyCode === duty) || {};
            let indexKey = isAliProduct ? selectedSet : riskIndex;

            let dutyAmount = typeof dutyList[duty] === 'object' ? dutyList[duty][indexKey] : dutyList[duty];
            if (duty === 'CV02432') {
              // 前端展示万元，值应该乘以 10000
              dutyAmount = dutyAmount * 10000;
            }
            // 团意产品中 CV01931 意外伤害住院津贴责任 前端展示日赔付额，但是报价的时候还是按照总赔付额来进行传值（日赔付额 * 180）
            if (isTeamAccidentProd && (duty === 'CV01931' || duty === 'CVJD006')) {
              dutyAmount = dutyAmount !== -1 ? dutyAmount * 180 : -1;
            }
            // 业务逻辑再次更改，主险下的责任项 页面选择不承保(-1)也要传给后端，选择不承保时insuredAmount(投保额)传0
            if (/^P06/.test(globalData['productCode']) && globalData['productCode'] < 'P060038') dutyAmount = (dutyAmount === -1 && planInfo[plan]['isMain'] === '1') ? 0 : dutyAmount;
            if (/^CV/.test(duty)) {
              let currentAmount = Number(dutyAmount) === -1 ? 0 : Number(dutyAmount);
              totalInsuredAmount = totalInsuredAmount + currentAmount; // 此处是原本的逻辑，没明白，保持不动
              totalInsuredAmountEvery = totalInsuredAmountEvery + currentAmount; // 此处为P060038及之后产品的逻辑
            }
            let obj = {
              dutyCode: duty,
              dutyName: currentDutyInfo['dutyChineseName'],
              insuredAmount: !/^CV/.test(duty) ? dutyAmount : Number(dutyAmount),
            };
            // P060039 dutyList 节点中需要传入 dutyAttributeInfoList
            if (globalData['productCode'] === 'P060039' || isAliProduct) {
              // 先把relationDutyCode的保额变成当前选中的保额
              let currentDutyAttributeInfoList = (currentDutyInfo.dutyAttributeInfoList || []).map((attr) => {
                let newAttr = _.cloneDeep(attr);
                if (newAttr.dutyAttrCode === currentDutyInfo.relationDutyCode) {
                  newAttr.dutyAttrAmountValue = obj['insuredAmount'];
                }
                newAttr.dutyAttrAmountValue = newAttr.dutyAttrAmountValue == -1 ? '0' : (newAttr.dutyAttrAmountValue + '');
                return newAttr;
              });

              if (duty === 'CV01382') {
                // 只有三者责任险的 16 和 42会跟着17联动
                // 每次事故赔偿限额(元)(dutyAttrCode 17)变化时，累计赔偿限额(元)(dutyAttrCode 16) 和 每人赔偿限额(元)(dutyAttrCode 42)也要跟着变化
                const dutyAttributeInfo_17 = currentDutyAttributeInfoList.find((attr) => attr.dutyAttrCode === '17');
                if (dutyAttributeInfo_17) {
                  const options_relation = getOptionalAttributeValueArr(dutyAttributeInfo_17.optionalAttributeValue);
                  const dutyAttrValueIndex = options_relation.findIndex((option) => option == dutyAttributeInfo_17.dutyAttrAmountValue); // 关联dutyAttrCode取得index
                  if (dutyAttrValueIndex > -1) {
                    currentDutyAttributeInfoList = currentDutyAttributeInfoList.map((attr) => {
                      if (attr.dutyAttrCode === '16' || attr.dutyAttrCode === '42') {
                        const currentOptions = getOptionalAttributeValueArr(attr.optionalAttributeValue);
                        if (currentOptions[dutyAttrValueIndex]) attr.dutyAttrAmountValue = currentOptions[dutyAttrValueIndex];
                      }
                      return attr;
                    });
                  }
                }
              }

              // 过滤数据：只需要传入dutyAttrAmountValue、dutyAttrCode、dutyAttributeName这三个参数就可以了
              currentDutyAttributeInfoList = currentDutyAttributeInfoList.map((attr) => ({
                dutyAttrAmountValue: attr.dutyAttrAmountValue,
                dutyAttrCode: attr.dutyAttrCode,
                dutyAttributeName: attr.dutyAttributeName,
              }));

              obj['dutyAttributeInfoList'] = currentDutyAttributeInfoList;
            } else if (globalData['productCode'] === 'P060028') {
              delete obj['insuredAmount'];
            }
            if (Number(dutyAmount) >= 0) { // 投保额可以为0，投保额为0也要返回给后端，过滤掉-1(不承保)
              dutyInfoListItem.push(obj);
            }
            return dutyIndex;
          });
        }

        // 所有投保值为0的职业,PL,CV都不返回给后端
        if (dutyInfoListItem.length > 0 && /^PL[\d|A-Z]+$/.test(plan)) {
          let planObj: PLAN_OBJ = {
            planName: planInfo[plan].planChineseName,
            isMain: planInfo[plan]['isMain'],
            planCode: plan,
            totalInsuredAmount: (globalData['productCode'] >= 'P060038' || isTeamAccidentProd) ? totalInsuredAmountEvery : totalInsuredAmount,
            dutyInfoList: dutyInfoListItem,
          };
          if (globalData['productCode'] === 'P060028') {
            delete planObj['totalInsuredAmount'];
          }
          planInfoList.push(planObj);
        }
        if (globalData['productCode'] === 'P060030' || globalData['productCode'] === 'P060039' || isAliProduct) {
          return planIndex;
        }
        planInfoList.map((planInfoItem) => { // 特约免赔需求，增加入参，不知道什么作用，需要从getProductInfo接口拿到数据作为commonQuote接口的入参
          globalData['appProductInfo']['packageList'].map((packageItem) => {
            if (packageItem.packageCode === packageCode) { // 选中的套餐
              packageItem.planList.map((planItem) => {
                if (planItem.planCode === planInfoItem.planCode) { // planCode相等
                  planInfoItem.dutyInfoList.map((dutyInfoItem) => {
                    dutyInfoItem.dutyAttributeInfoList = [];
                    planItem.dutyList.map((dutyItem) => {
                      if (dutyItem.dutyCode === dutyInfoItem.dutyCode) { // dutyCode相等
                        (dutyItem.dutyAttributeInfoList || []).map((dutyAttrItem) => {
                          dutyInfoItem.dutyAttributeInfoList.push({
                            dutyAttrCode: dutyAttrItem.dutyAttrCode,
                            dutyAttrAmountValue: dutyAttrItem.dutyAttrAmountValue,
                            dutyAttributeName: dutyAttrItem.dutyAttributeName,
                          });
                        });
                      }
                    });
                  });
                }
              });
            }
          });
        });
        return planIndex;
      });

      let riskData = {
        riskGroupName: riskGroupNameList[riskIndex],
        riskGroupType: '0' + riskGroupType,
        applyRiskNum: 1,
        applyNum: 1,
        productPackageType: packageCode,
        planInfoList,
        riskPropertyInfoList: [] as any,
      };
      riskData.riskPropertyInfoList.push({
        employerInsuranceNum: item,
        workTypeCode: riskGroupWorkTypeList[riskIndex],
      });
      if (YiJianXianList.includes(globalData['productCode']) || globalData['productCode'] === 'P060030') { // 意健险，多标的
        riskData.riskPropertyInfoList[0]['accidentInsuranceNum'] = item;
        delete riskData.riskPropertyInfoList[0]['employerInsuranceNum'];
      } else if (globalData['productCode'] === 'P060028') { // 小微亚马逊
        let riskAmazonData = formData['riskInfo'] || [];
        riskAmazonData.forEach((item) => {
          if (item.productDataType instanceof Array) {
            item.productTypeOne = item.productDataType[0];
            item.productTypeTwo = item.productDataType[1];
          }
        });
        delete riskData.riskPropertyInfoList;
        riskData.riskPropertyInfoList = riskAmazonData;
      }
      return riskData;
    });
  }

  // 过滤undefined的数据不返回给后端
  let riskGroupInfoListFilter: any[] = [];
  let planInfoListNoRelation: any[] = []; // P060039 不与职业相关的险种信息
  const sellingAreaData = currentTableData['sellingArea'] ? currentTableData['sellingArea']['sellingArea'][0] : '';
  for (const item of riskGroupInfoList) {
    if (item !== undefined) {
      let copyItem = _.cloneDeep(item);
      if (globalData['productCode'] === 'P060017') {
        // 小微免核雇主责任险
        if (formData['riskGroup' + selectedSet] instanceof Array && formData['riskGroup' + selectedSet].length >= 5) {
          copyItem['riskPropertyInfoList'][0]['fiveAndSixProfessionRatio'] = (formData['riskGroup' + selectedSet][4] / sumPerson).toFixed(2);
        } else {
          copyItem['riskPropertyInfoList'][0]['fiveAndSixProfessionRatio'] = '0';
        }
      } else if (globalData['productCode'] === 'P060039') {
        // 小微企业安心保
        copyItem['riskPropertyInfoList'][0]['employerInsuranceNum'] = copyItem.riskPropertyInfoList[0].accidentInsuranceNum;
        if (sellingAreaData) {
          copyItem['riskPropertyInfoList'][0]['sellingArea'] = sellingAreaData;
        }
        if (formData['riskGroup' + selectedSet] instanceof Array && formData['riskGroup' + selectedSet].length >= 5) {
          copyItem['riskPropertyInfoList'][0]['fiveAndSixProfessionRatio'] = (formData['riskGroup' + selectedSet][4] / sumPerson).toFixed(2);
        } else {
          copyItem['riskPropertyInfoList'][0]['fiveAndSixProfessionRatio'] = '0';
        }
        // 与职业类别相关的险种(意健险)
        const relationProfessionPlanCode = ['PL1800205', 'PL1800206', 'PL1800216', 'PL1800258', 'PL1800208', 'PL1800212'];
        if (item.planInfoList instanceof Array) {
          if (item.riskGroupType === '01') planInfoListNoRelation = item.planInfoList.filter((planInfo: any) => !relationProfessionPlanCode.includes(planInfo.planCode));
          copyItem.planInfoList = item.planInfoList.filter((planInfo: any) => relationProfessionPlanCode.includes(planInfo.planCode));
        }
      } else if (isAliProduct && productCode !== "P060090") {
        // 小微1688电商保(P060090不含雇主险，因此不需要进行过滤)
        // 与职业类别相关的险种(意健险)
        const relationProfessionPlanCode = ['PL0700902'];
        if (item.planInfoList instanceof Array) {
          if (item.riskGroupType === '01') planInfoListNoRelation = item.planInfoList.filter((planInfo: any) => !relationProfessionPlanCode.includes(planInfo.planCode));
          copyItem.planInfoList = item.planInfoList.filter((planInfo: any) => relationProfessionPlanCode.includes(planInfo.planCode));
        }
      }
      riskGroupInfoListFilter.push(copyItem);
    }
  }
  // 同时存在与职业类别相关的险种和与职业类别无关的险种时
  if (globalData['productCode'] === 'P060039') {
    riskGroupInfoListFilter.push({
      applyNum: 1,
      applyRiskNum: 1,
      planInfoList: planInfoListNoRelation,
      productPackageType: packageCode,
      riskPropertyInfoList: [
        { sellingArea: sellingAreaData, employerInsuranceNum: 0 },
      ],
    });
    riskGroupInfoListFilter = riskGroupInfoListFilter.filter((item) => item.planInfoList && item.planInfoList.length > 0);
  } else if (isAliProduct) {
    if (productCode === "P060090") {
      riskGroupInfoListFilter = riskGroupInfoList
    } else {
      riskGroupInfoListFilter.push({
        applyNum: 1,
        applyRiskNum: 1,
        planInfoList: planInfoListNoRelation,
        productPackageType: packageCode,
        riskPropertyInfoList: [
          { employerInsuranceNum: 0 },
        ],
      });
      riskGroupInfoListFilter = riskGroupInfoListFilter.filter((item) => item.planInfoList && item.planInfoList.length > 0);
    }
  }

  let commonParams = {
    timeStr: formData['timeStr'],
    productCode: globalData['productCode'], // 产品Id
    flowId: globalData['flowId'], // 流程号
    applyPeriod: {
      term: '12', // 小微产品固定为12个月 1年期限的投保（P060032为短期产品）
      termUnit: 'M',
    },
    effectDate: {
      addDays,
      beginDate: moment().add(addDays, 'd').format('YYYY-MM-DD'), // 投保启期为当前时间后一天
      endDate: moment().add(addDays - 1, 'd').add(1, 'year').format('YYYY-MM-DD'), // 结束日期为当前日期+顺延时间+加一年
    },
    insurantNum: [{
      personNum: '1',
      subjectType: '02',
    }],
    microQuoteForm: {
      applyNum: 1,
      employeesNum: sumPerson, // 雇佣人数
      productCode: globalData['productCode'],
      departmentCode: globalData['dpt'][address[1]['code'] || ''] || '20127', // 如果是isAliProduct（电商保）departmentCode前端虽然传了，但是后端不会取
      riskPropertyInfoList: [{
        area: '',
        propertyValue: '',
        inventoryValue: '',
        cashValue: '',
        // 清单名称，acplPersonnelList：意健，personnelList:雇主或一般
        [personnelListKeyName]: [],
        employeesNum: sumPerson, // 总人数
      }],
      marketProductCode: appProductInfo['marketProductCode'], // 产品的市场便吗
      productVersion: appProductInfo['version'], // 产品版本号
      packageCode,
      totalAssets: formData['totalAssets'] || '',
      province: address[0]['code'], // 省级地区编码
      provinceName: address[0]['name'], // 省级地区名称
      city: address[1]['code'], // 市级地区编码
      cityName: address[1]['name'], // 市级地区名称
      county: (address[2] || {})['code'] || '', // 县级地区编码
      countyName: (address[2] || {})['name'] || '', // 县级地区名称
      holdType: formData['entreProperty'], // 投保人类型 S为个人 G为企业
      riskGroupInfoList: riskGroupInfoListFilter, // 各个职业类型的投保信息
      industryType1: formData['industry'][0], // 行业类型 1-4级
      industryType2: formData['industry'][1],
      industryType3: formData['industry'][2],
      industryType4: formData['industry'][3],
      saleInfo: {
        departmentCode: globalData['dpt'][address[1]['code'] || ''] || '20127',
        channelSourceCode: 6,
      },
    },
    planPackage: {
      packageCode,
      marketProductCode: appProductInfo['marketProductCode'],
    },
  };

  if (isAliProduct) {
    commonParams['paymentType'] = formData['paymentMethod'];
    commonParams['effectDate']['beginDate'] = globalData['beginDate'];
    commonParams['effectDate']['endDate'] = globalData['endDate'];
    if (productCode === "P060090") { // 赠险 保险期限为一个月
      commonParams["applyPeriod"]["term"] = "1";
      commonParams["applyPeriod"]["termUnit"] = "M";
    }
  } else if (isTeamAccidentProd) {
    // 保险期限
    const termValue = (formData['applyPeriod'] || {}).termValue || '';
    const term = termValue ? parseInt(termValue) : 0;
    const termUnit = termValue ? termValue.replace(/[0-9]/g, '') : 'M';
    commonParams['applyPeriod']['term'] = String(term);
    commonParams['applyPeriod']['termUnit'] = termUnit;
    
    commonParams['effectDate']['beginDate'] = moment(formData['insured-date']).format('YYYY-MM-DD');
    commonParams['effectDate']['endDate'] = moment(commonParams['effectDate']['beginDate']).add(-1, 'd').add(term, termUnit === "D" ? "d" : termUnit).format('YYYY-MM-DD');
  } else if (productCode === 'P060017') {
    // 完整地址需要拼接省市区详细地址
    let provinceName = commonParams['microQuoteForm']['provinceName'] || '';
    let cityName = commonParams['microQuoteForm']['cityName'] || '';
    let countyName = commonParams['microQuoteForm']['countyName'] || '';
    let detailAddress = formData['detailAddress'] || '';
    commonParams['microQuoteForm']['wholeAddress'] = `${provinceName}${cityName}${countyName}${detailAddress}`;
  }

  // 添加标的信息
  if (globalData['isShowTargetForm']) {
    try {
      const microTargetNameList = globalData['targetFormList'].filter((item) => item.isShow).map((item) => item.name);
      // 处理标的信息
      const targetPropertyObj = formData['targetPropertyList'];
      let microTargetList: any[] = [];
      if (targetPropertyObj) {
        for (let key in targetPropertyObj) {
          if (microTargetNameList.includes(key)) {
            microTargetList.push({
              propertyKey: key,
              propertyValue: targetPropertyObj[key],
            });
          }
        }
      }
      commonParams['microQuoteForm']['microTargetList'] = microTargetList;
    } catch (e) {
      console.error('处理标的信息失败', e);
    }
  }
  // 有雇员时候传riskGroupInfoList，没有雇员时传riskPropertyInfoList（包括意健险人员清单时）
  if (globalData['productCode'] === 'P060026' && formData['riskGroup' + selectedSet] instanceof Array && formData['riskGroup' + selectedSet].length >= 5) {
    // 五类职业占比
    if (formData['riskGroup0'][4] > 0) {
      commonParams.microQuoteForm.riskPropertyInfoList[0]['fiveAndSixProfessionRatio'] = (formData['riskGroup' + selectedSet][4] / sumPerson).toFixed(2);
    } else {
      commonParams.microQuoteForm.riskPropertyInfoList[0]['fiveAndSixProfessionRatio'] = '0';
    }
  } else if (globalData['productCode'] === 'P060030') {
    // 多标的（多个职业类型）才传riskGroupInfoList,P060030不需要传该参数
    delete (commonParams as any).microQuoteForm['riskGroupInfoList'];
    commonParams.microQuoteForm.riskPropertyInfoList[0]['accidentInsuranceNum'] = sumPerson;
    // 如果planDuty中存"财产一切险，标的：存货因火灾爆炸受损PL1000002/CV01471"则将单位万元换成元
    planDuty.forEach((item) => {
      if (item.planCode === 'PL1000002' && item.dutyCode === 'CV01471') {
        item.value = item.value * 10000;
      }
    });
    commonParams['planDuty'] = planDuty.filter((item) => /^CV/.test(item.dutyCode));
    const sellingAreaData = planDuty.find((item) => item.dutyCode === 'sellingArea');
    // 处理标的信息
    commonParams['microQuoteForm']['microTargetList'] = sellingAreaData ? [
      { propertyKey: sellingAreaData['dutyCode'], propertyValue: sellingAreaData['value'] },
    ] : [];
  } else if (globalData['productCode'] === 'P060039' || isAliProduct) {
    commonParams.microQuoteForm.riskPropertyInfoList[0]['accidentInsuranceNum'] = sumPerson;
    // 这里虽然是意健险，但是不传employerInsuranceNum，GAC报价会出错
    commonParams.microQuoteForm.riskPropertyInfoList[0]['employerInsuranceNum'] = sumPerson;
  } else if (isNoStaff) {
    // 没有雇员人数时
    // 新增入餐“场所类型”
    if (formData['placeType'] && formData['placeType'].length > 0) {
      formData['placeType'].forEach((item, index) => {
        commonParams.microQuoteForm['placeType' + (index + 1)] = formData['placeType'][index];
      });
    }
    // 删除riskGroupInfoList
    delete (commonParams as any).microQuoteForm['riskGroupInfoList'];
    commonParams.microQuoteForm.riskPropertyInfoList[0]['accidentInsuranceNum'] = sumPerson;
    commonParams['planDuty'] = planDuty;

    if (globalData['productCode'] === 'P060032') {
      commonParams.applyPeriod.termUnit = 'D';
      const DateRange = formData['datepicker'];
      if (DateRange && DateRange.length > 0) {
        commonParams.applyPeriod.term = (DateRange[1].diff(DateRange[0], 'd') + 1) + '';
        commonParams.effectDate = {
          addDays,
          beginDate: DateRange[0].format('YYYY-MM-DD'), // 投保启期为当前时间后一天
          endDate: DateRange[1].format('YYYY-MM-DD'), // 结束日期为当前日期+顺延时间+加一年
        };
      } else {
        commonParams.applyPeriod.term = '30';
        commonParams.effectDate = {
          addDays,
          beginDate: '',
          endDate: '',
        };
      }
    }
  } else if (globalData['productCode'] === 'P060038') {
    commonParams['planDuty'] = planDuty;
    // 意健险
    // delete commonParams["microQuoteForm"]["riskGroupInfoList"]
    commonParams['microQuoteForm']['riskPropertyInfoList'][0]['accidentInsuranceNum'] = sumPerson;
  }
  const url = BASE_HOST + '/pa18shopnst/do/era/quote/commonQuote';
  return axios.post(
    url,
    commonParams,
  );
};

// 查询1688电商保订单信息
export const queryAliOrderInfo = (params) => axios.request({
  method: 'post',
  params: {
    applyPolicyNo: params.applyPolicyNo,
  },
  url: BASE_HOST + '/pa18shopnst/do/mciro/commonen/queryAliPolicy',
});

// 查询1688电商保订单信息
export const queryAliOrderInfoSingle = (params) => axios.request({
  method: 'post',
  params: {
    applyPolicyNo: params.applyPolicyNo,
  },
  url: BASE_HOST + '/pa18shopnst/do/mciro/commonen/queryAliPolicyInfo',
});

// 存单接口
export const saveApplyInfo = (formData: any) => {
  // 通用参数
  const { aliProductCodes, productCode, teamAccidentProds } = globalData;
  const appProductInfo = globalData['appProductInfo']; // 产品信息
  const selectedSet = globalData['selectedSet']; // 当前选择的套餐
  const packageCode = appProductInfo['packageList'][selectedSet]['packageCode']; // 当前packageCode
  const microQuoteForm = _.cloneDeep(globalData['quoteInfo']['microQuoteForm']); // 报价后返回的报价信息
  const quoteInfo = _.cloneDeep(globalData['quoteInfo']);
  const addDays = (appProductInfo['insurancePeriodInfo'] || {}).shortestEffectiveTime || 1;
  const isAliProduct = aliProductCodes.includes(productCode);
   // 是否是团意产品
   const isTeamAccidentProd = teamAccidentProds.includes(productCode);
  // 发票信息处理
  const expressAdress = isAliProduct ? {} : ExpressAddressSplit(formData['express']);
  let personnelListKeyName = 'personnelList';
  // 小微清单规则：01-不需要清单；02-雇员清单；03-意健险清单；04-只需要一个意健险清单
  // 此处P060038如果不勾选意外险，persionListRule会返回01，此时也需要上传人员清单，否则会被核保接口校验住
  if (globalData['persionListRule'] === '03' || globalData['productCode'] === 'P060038') {
    personnelListKeyName = 'acplPersonnelList';// 意健清单名称
  }
  if (isTeamAccidentProd) {
    personnelListKeyName = 'personnelList'
  }
  const expressInfoTemplate = {
    postFlag: '03',
    invoiceHeading: formData['enterprise']['myGroupName'], // 发票抬头
    receiveName: '',
    receiveMobile: '',
    receiveAddress: '',
    permit: true,
    customerType: 'G',
    provinceCode: '',
    provinceName: '',
    cityCode: '',
    cityName: '',
    areaName: '',
    areaCode: '',
    townName: '',
    townCode: '',
    taxPayerType: '02',
    invoiceType: '',
    taxPayerAddress: '',
    taxPayerBankAccount: '',
    taxPayerBankName: '',
    taxPayerNo: '',
    taxPayerTel: '',
  };
  const express = Object.assign(expressInfoTemplate, formData['express'], expressAdress);
  // 人员信息处理 优先取excel上传后的数据
  const personnelList = formData['personnelListExcel'] ? formData['personnelListExcel'] : formData[personnelListKeyName];
  for (const index in personnelList) {
    let personnelListItem = _.cloneDeep(personnelList[index]);
    for (const subIndex in personnelListItem) {
      if (personnelListItem[subIndex]) {
        let occupationArr = personnelListItem[subIndex]['occupationCode'] || null;
        // occupationCode:职业代码，position：岗位名称/职业名称
        // 数组只有一项就取第一项，数组有多项就取第四级职业类型
        if (occupationArr instanceof Array) {
          personnelListItem[subIndex]['occupationCode'] = occupationArr.length === 1 ? occupationArr[0] : occupationArr.slice(-1)[0];
        }
        if (microQuoteForm['riskGroupInfoList']) {
          // 强制设置内层职业类型code保持和外层的一致，避免内外职业类型不一致
          personnelListItem[subIndex]['workTypeCode'] = microQuoteForm['riskGroupInfoList'][Number(index) - 1]['riskPropertyInfoList'][0]['workTypeCode'];
        }
        personnelListItem[subIndex]['name'] = personnelListItem[subIndex]['fullName'];

        if (YiJianXianList.includes(globalData['productCode'])) {
          // 团险安心保 特殊处理 P060027 ， 人员信息 中position， name字段，上传清单时不做做处理，但填写时要处理
          if (formData['personnelListExcel']) {
            personnelListItem[subIndex]['occupationCode'] = '';
            personnelListItem[subIndex]['birthDay'] = personnelListItem[subIndex]['birthDate'];
          } else { // 手动填写表单
            let idInfo = getIdCardInfo(personnelListItem[subIndex]['certificateNo']);
            personnelListItem[subIndex]['sexCode'] = idInfo['sex'] || '';
            personnelListItem[subIndex]['birthDay'] = idInfo['birthDay'] || '';
          }
          // 这些固定写死
          personnelListItem[subIndex]['personnelAttribute'] = '真实';
          personnelListItem[subIndex]['personnelNature'] = '主被保险人';
          personnelListItem[subIndex]['beneficiaryInLaw'] = true;
        } else {
          let positionArr = personnelListItem[subIndex]['position'] || null;
          if (isTeamAccidentProd && !formData['personnelListExcel']) {
            // 手动填写
            personnelListItem[subIndex]['professionCode'] = personnelListItem[subIndex]['occupationCode'] || '';
            // 手动填写的时候，出生日期为moment格式，需要转化成 YYYY-MM-DD
            personnelListItem[subIndex]['birthDay'] = moment(personnelListItem[subIndex]['birthDay']).format('YYYY-MM-DD');
          }
          // 处理P060030
          if ('P060030' === globalData['productCode']) {
            console.log('小微企业保-生日信息特殊处理');
            // 是否要放开需要确认occupationCode
            // occupationCode:职业代码，position：岗位名称/职业名称
            // personnelListItem[subIndex]['occupationCode']="";
            // 下载模板没有职业code
            if (formData['personnelListExcel']) {
              personnelListItem[subIndex]['birthDay']=personnelListItem[subIndex]['birthDate'];
              console.log('由于服务端赋值数据定义原因，生日信息赋值给日期');
            } else {
              // 手工处理生日和性别信息
              let idInfo = getIdCardInfo(personnelListItem[subIndex]['certificateNo']);
              console.log(subIndex + '人员信息：' + idInfo);
              personnelListItem[subIndex]['sexCode'] = idInfo['sex'] || '';
              personnelListItem[subIndex]['birthDay'] = idInfo['birthDay'] || '';
            }
          }
          if (globalData['templateVersionFlag']) {
            if (positionArr instanceof Array) {
              personnelListItem[subIndex]['position'] = positionArr.length == 1 ? positionArr[0] : positionArr.slice(-1)[0];
            } else {
              personnelListItem[subIndex]['position'] = positionArr;
            }
          } else {
            if (positionArr instanceof Array) {
              personnelListItem[subIndex]['position'] = positionArr.length == 1 ? positionArr[0] : positionArr.slice(-1)[0];
            } else {
              if ('P060030' === globalData['productCode'] && formData['personnelListExcel']) {
                console.log('批量上传,不处理职业信息');
              } else {
                // 职业编码赋值给岗位名称, 这种设计着实不妥 P060030需要展示手动选择的职业名称
                if ('P060030' === globalData['productCode']) {
                  console.log('不进行职业编码替换职业');
                } else {
                  personnelListItem[subIndex]['position'] = personnelListItem[subIndex]['occupationCode'];
                }
              }
            }
          }
        }
      }
      // 人员信息直接添加到microQuoteForm中
      // 01,不需要传清单列表(此处P060038如果不勾选意外险，persionListRule会返回01，此时也需要上传人员清单，否则会被核保接口校验住)
      if (globalData['persionListRule'] != '01' || globalData['productCode'] === 'P060038' || isTeamAccidentProd) {
        let rIndex = isNaN(Number(index) - 1) ? 0 : Number(index) - 1;
        if (microQuoteForm['riskGroupInfoList']) {
          microQuoteForm['riskGroupInfoList'][rIndex]['riskPropertyInfoList'][0][personnelListKeyName] = personnelListItem;
          if (globalData['productCode'] === 'P060038') {
          // 做特殊处理，由于后端不会去riskGroupInfoList中取清单信息，需要将意健险清单数据放置到外层
            microQuoteForm['riskPropertyInfoList'] = _.cloneDeep(microQuoteForm['riskGroupInfoList'][rIndex]['riskPropertyInfoList']);
          }
        } else if (microQuoteForm['riskPropertyInfoList']) {
          microQuoteForm['riskPropertyInfoList'][Number(index) - 1][personnelListKeyName] = personnelListItem;
        }
      }
    }
  }

  // 被保人电话号码
  const insurant_telephone = formData['insured_person_telephoto'] ? formData['insured_person_telephoto'].split('-') : ['', '', ''];
  // 投保人电话号码
  const holder_telephone = formData['policy_holder_telephoto'] ? formData['policy_holder_telephoto'].split('-') : ['', '', ''];
  // 投保企业地址
  microQuoteForm['address'] = formData['enterprise']['groupAddressDetail'];
  // 投保企业详细地址
  microQuoteForm['wholeAddress'] = `${microQuoteForm['provinceName'] || ''}${microQuoteForm['cityName'] || ''}${microQuoteForm['countyName'] || microQuoteForm['areaName'] || ''}${formData['enterprise']['groupAddressDetail'] || ''}`;
  let commonParams = {
    insurant: [
      {
        certStart: moment(formData['insurant']['certStart']).format('YYYY-MM-DD'),
        certEnd: moment(formData['insurant']['certEnd']).format('YYYY-MM-DD'),
        insurantName: formData['insurant']['name'], // 被保人名称
        mobileTelephone: formData['insurant']['mobileTelephone'], // 被保人移动电话
        telephoneAreaCode: insurant_telephone[0] || '', // 被保人固定电话区号
        telephoneNumber: insurant_telephone[1] || '', // 被保人固定电话
        telephoneSubNumber: insurant_telephone[2] || '', // 被保人固定电话分机号
        provinceCode: microQuoteForm['province'], // 省以及城市地区 取报价中的值
        provinceName: microQuoteForm['provinceName'],
        cityCode: microQuoteForm['city'],
        cityName: microQuoteForm['cityName'],
        areaCode: microQuoteForm['county'] || microQuoteForm['area'],
        areaName: microQuoteForm['countyName'] || microQuoteForm['areaName'],
        detailAddress: formData['insered_person_address'], // 被保人详细地址
        holderType: microQuoteForm['holdType'], // 投保人种类 S个人 G企业
        subjectType: '02',
        relationshipWithInsurer: '9',
        certificateType:
          microQuoteForm['holdType'] === 'G'
            ? '01'
            : formData['insurant']['idtype'], // 个人投保需要填写个人证件类型 企业则默认为01
        certificateNumber:
          microQuoteForm['holdType'] === 'G'
            ? formData['enterprise']['groupCertificateNo']
            : formData['insurant']['idNo'], // 个人投保需要填写个人证件号码 企业为企业证件号码
        groupName: formData['enterprise']['myGroupName'], // 企业名称
        groupCertificateType: formData['enterprise']['groupIdType'], // 企业证件号码 默认为05
        groupCertificateNo: formData['enterprise']['groupCertificateNo'], // 企业证件号码
        groupIndustryCodeLevel2: 'E509',
        groupAreaCode: '0',
        groupAreaName: '',
        groupAddressDetail: formData['enterprise']['groupAddressDetail'], // 企业详细地址
      },
    ],
    planPackage: {
      marketProductCode: appProductInfo['marketProductCode'], // 产品市场编码
      packageType: null,
      packageName: null,
      dutyList: null,
      packageCode, // 产品packageCode
    },
    professionType: appProductInfo['packageList'][selectedSet].professionType || appProductInfo['professionType'], // 产品职业当前套餐的职业类型
    applyPeriod: { // 投保期限 默认为12个月1年
      term: 12,
      termUnit: 'M',
    },
    insurantNum: [{
      personNum: 1,
      subjectType: '02',
    }],
    effectDate: {
      addDays,
      endDate: moment(formData['insured-date']).add(-1, 'd').add(1, 'year').format('YYYY-MM-DD'), // 投保结束日期
      birthDay: null,
      beginDateFixed: false,
      beginDate: moment(formData['insured-date']).format('YYYY-MM-DD'), // 投保起期
    },
    microQuoteForm,
    // 投保人
    applicant: {
      certStart: moment(formData['certStart']).format('YYYY-MM-DD'),
      certEnd: moment(formData['certEnd']).format('YYYY-MM-DD'),
      groupName: formData['enterprise']['myGroupName'], // 投保人企业名称
      groupIdType: formData['enterprise']['groupIdType'],
      groupIdNum: formData['enterprise']['groupCertificateNo'], // 投保人企业编码
      provinceCode: microQuoteForm['province'], // 投保人地址信息 取报价中的省市区的值
      provinceName: microQuoteForm['provinceName'],
      cityCode: microQuoteForm['city'],
      cityName: microQuoteForm['cityName'],
      areaCode: microQuoteForm['county'] || microQuoteForm['area'],
      areaName: microQuoteForm['countyName'] || microQuoteForm['areaName'],
      email: formData['email'],
      // "email": globalData['userEmail'], //投保人的电子邮箱 在信息填写页面通过queryUser拉取 电销用户则是在url上读取
      holdType: microQuoteForm['holdType'], // 投保人的类型 S为个人 G为企业
      name: formData['policy_holder_name'], // 投保人名称
      mobileTelephone: formData['policy_holder_mobile'], // 投保人移动电话号码
      telephoneAreaCode: holder_telephone[0] || '', // 投保人固定电话区号
      telephoneNumber: holder_telephone[1] || '', // 投保人固定电话号码
      telephoneSubNumber: holder_telephone[2] || '', // 投保人分机号码
      address: formData['policy_holder_address'], // 投保人地址
      certificateType: microQuoteForm['holdType'] === 'G' ? '01' : formData['policy_holder_idtype'], // 投保人为个人时需要选择投保人证件类型 企业则默认为01
      certificateNumber: microQuoteForm['holdType'] === 'G' ? formData['enterprise']['groupCertificateNo'] : formData['policy_holder_idNo'], // 投保人证件号码
    },
    sendDetail: express, // 发票相关信息
  };
  // 标的信息赋值
  if (globalData['isShowTargetForm']) {
    if (microQuoteForm['microTargetList']) {
      commonParams['microQuoteForm']['microTargetList'] = _.cloneDeep(microQuoteForm['microTargetList']);
    }
  }
  if (globalData['productCode'] === 'P060028') {
    commonParams['documentGroupIdList'] = formData['documentGroupIdList'].split(',');
  } else if (globalData['productCode'] === 'P060030') {
    if (microQuoteForm['microTargetList']) {
      commonParams['microQuoteForm']['microTargetList'] = _.cloneDeep(microQuoteForm['microTargetList']);
    }
  } else if (globalData['productCode'] === 'P060032') {
    try {
      commonParams.applyPeriod = _.cloneDeep(quoteInfo['applyPeriod']);
      commonParams.effectDate.beginDate = quoteInfo['effectDate']['beginDate'];
      commonParams.effectDate.endDate = quoteInfo['effectDate']['endDate'];
    } catch (e) {
      console.error('处理信息失败', e);
    }
  } else if (isAliProduct) {
    commonParams['effectDate']['beginDate'] = quoteInfo['effectDate']['beginDate'];
    commonParams['effectDate']['endDate'] = quoteInfo['effectDate']['endDate'];
    if (globalData['productCode'] === "P060090") {
      commonParams['applyPeriod']['term'] = 1;
      commonParams['applyPeriod']['termUnit'] = "M";
    }
  } else if (isTeamAccidentProd) {
    commonParams['applyPeriod']['term'] = quoteInfo['applyPeriod']['term'];
    commonParams['applyPeriod']['termUnit'] = quoteInfo['applyPeriod']['termUnit'];
    commonParams['effectDate']['beginDate'] = quoteInfo['effectDate']['beginDate'];
    commonParams['effectDate']['endDate'] = quoteInfo['effectDate']['endDate'];
  }
  const url = BASE_HOST + '/pa18shopnst/do/era/save/saveApplyInfo?flowId=' + globalData['flowId'];
  return axios.post(
    url,
    commonParams,
  );
};

// 暂存保存
export const saveTempApplyInfo = (formData: any) => {
  // 通用参数
  const { productCode, teamAccidentProds } = globalData;
  // 是否是团意产品
  const isTeamAccidentProd = teamAccidentProds.includes(productCode);
  const isAliProduct = globalData['aliProductCodes'].includes(productCode);
  const appProductInfo = globalData['appProductInfo']; // 产品信息
  const selectedSet = globalData['selectedSet']; // 当前选择的套餐
  const quoteInfo = _.cloneDeep(globalData['quoteInfo'] || {});
  const { applyPeriod, effectDate } = quoteInfo;
  const microQuoteForm = isAliProduct ? {} : _.cloneDeep(globalData['quoteInfo']['microQuoteForm']); // 报价后返回的报价信息
  let temAddress = {
    provinceCode: '',
    provinceName: '',
    cityCode: '',
    cityName: '',
    areaCode: '',
    areaName: '',
    townCode: '',
    townName: '',
  };
  // 发票信息处理
  const addressObj = formData['express'] || {};
  for (const item in addressObj) {
    if (addressObj[item] && item === 'province') {
      temAddress.provinceName = addressObj[item].split('_')[0];
      temAddress.provinceCode = addressObj[item].split('_')[1];
    }
    if (addressObj[item] && item === 'city') {
      temAddress.cityName = addressObj[item].split('_')[0];
      temAddress.cityCode = addressObj[item].split('_')[1];
    }
    if (addressObj[item] && item === 'area') {
      temAddress.areaName = addressObj[item].split('_')[0];
      temAddress.areaCode = addressObj[item].split('_')[1];
    }
    if (addressObj[item] && item === 'town') {
      temAddress.townName = addressObj[item].split('_')[0];
      temAddress.townCode = addressObj[item].split('_')[1];
    }
  }
  const expressAdress = temAddress;
  const expressInfoTemplate = {
    postFlag: '03',
    invoiceHeading: formData['enterprise']['myGroupName'], // 发票抬头
    receiveName: '',
    receiveMobile: '',
    receiveAddress: '',
    permit: true,
    customerType: 'G',
    provinceCode: '',
    provinceName: '',
    cityCode: '',
    cityName: '',
    areaName: '',
    areaCode: '',
    townName: '',
    townCode: '',
    taxPayerType: '02',
    invoiceType: '',
    taxPayerAddress: '',
    taxPayerBankAccount: '',
    taxPayerBankName: '',
    taxPayerNo: '',
    taxPayerTel: '',
  };
  if (!isAliProduct) {
    delete formData['express']['province'];
    delete formData['express']['city'];
    delete formData['express']['area'];
    delete formData['express']['town'];
  }

  const express = Object.assign(expressInfoTemplate, formData['express'], expressAdress);

  // 被保人电话号码
  const insurant_telephone = formData['insured_person_telephoto'] ? formData['insured_person_telephoto'].split('-') : ['', '', ''];
  // 投保人电话号码
  const holder_telephone = formData['policy_holder_telephoto'] ? formData['insured_person_telephoto'].split('-') : ['', '', ''];
  // 投保企业地址
  microQuoteForm['address'] = formData['enterprise']['groupAddressDetail'];
  // 投保企业详细地址
  microQuoteForm['wholeAddress'] = `${microQuoteForm['provinceName'] || ''}${microQuoteForm['cityName'] || ''}${microQuoteForm['countyName'] || microQuoteForm['areaName'] || ''}${formData['enterprise']['groupAddressDetail'] || ''}`;

  let saveTemParams = {
    insurant: [{
      insurantName: formData['insurant']['name'], // 被保人名称
      mobileTelephone: formData['insurant']['mobileTelephone'], // 被保人移动电话
      telephoneAreaCode: insurant_telephone[0] || '', // 被保人固定电话区号
      telephoneNumber: insurant_telephone[1] || '', // 被保人固定电话
      telephoneSubNumber: insurant_telephone[2] || '', // 被保人固定电话分机号
      provinceCode: microQuoteForm['province'], // 省以及城市地区 取报价中的值
      provinceName: microQuoteForm['provinceName'],
      cityCode: microQuoteForm['city'],
      cityName: microQuoteForm['cityName'],
      areaCode: microQuoteForm['county'] || microQuoteForm['area'],
      areaName: microQuoteForm['countyName'] || microQuoteForm['areaName'],
      detailAddress: formData['insered_person_address'], // 被保人详细地址
      holderType: microQuoteForm['holdType'], // 投保人种类 S个人 G企业
      subjectType: '02',
      relationshipWithInsurer: '9',
      certificateType: microQuoteForm['holdType'] === 'G' ? '01' : formData['insurant']['idtype'], // 个人投保需要填写个人证件类型 企业则默认为01
      certificateNumber: microQuoteForm['holdType'] === 'G' ? formData['enterprise']['groupCertificateNo'] : formData['insurant']['idNo'], // 个人投保需要填写个人证件号码 企业为企业证件号码
      groupName: formData['enterprise']['insGroupName'], // 企业名称
      groupCertificateType: formData['enterprise']['groupIdType'], // 企业证件号码 默认为05
      groupCertificateNo: formData['enterprise']['groupCertificateNo'], // 企业证件号码
      groupIndustryCodeLevel2: 'E509',
      groupAreaCode: '0',
      groupAreaName: '',
      groupAddressDetail: formData['enterprise']['groupAddressDetail'], // 企业详细地址
    }],
    professionType: appProductInfo['packageList'][selectedSet].professionType || appProductInfo['professionType'], // 产品职业当前套餐的职业类型
    applyPeriod: { // 投保期限 默认为12个月1年
      term: 12,
      termUnit: 'M',
    },
    insurantNum: [{
      personNum: 1,
      subjectType: '02',
    }],
    effectDate: {
      addDays: null,
      endDate: moment(formData['insured-date']).add(-1, 'd').add(1, 'year').format('YYYY-MM-DD'), // 投保结束日期
      birthDay: null,
      beginDateFixed: false,
      beginDate: moment(formData['insured-date']).format('YYYY-MM-DD'), // 投保起期
    },
    applicant: {
      groupName: formData['enterprise']['myGroupName'], // 投保人企业名称
      groupIdType: formData['enterprise']['groupIdType'],
      groupIdNum: formData['enterprise']['groupCertificateNo'], // 投保人企业编码
      provinceCode: microQuoteForm['province'], // 投保人地址信息 取报价中的省市区的值
      provinceName: microQuoteForm['provinceName'],
      cityCode: microQuoteForm['city'],
      cityName: microQuoteForm['cityName'],
      areaCode: microQuoteForm['county'] || microQuoteForm['area'],
      areaName: microQuoteForm['countyName'] || microQuoteForm['areaName'],
      email: formData['email'],
      // "email": globalData['userEmail'], //投保人的电子邮箱 在信息填写页面通过queryUser拉取 电销用户则是在url上读取
      holdType: microQuoteForm['holdType'], // 投保人的类型 S为个人 G为企业
      name: formData['policy_holder_name'], // 投保人名称
      mobileTelephone: formData['policy_holder_mobile'], // 投保人移动电话号码
      telephoneAreaCode: holder_telephone[0] || '', // 投保人固定电话区号
      telephoneNumber: holder_telephone[1] || '', // 投保人固定电话号码
      telephoneSubNumber: holder_telephone[2] || '', // 投保人分机号码
      address: formData['policy_holder_address'], // 投保人地址
      certificateType: microQuoteForm['holdType'] === 'G' ? '01' : formData['policy_holder_idtype'], // 投保人为个人时需要选择投保人证件类型 企业则默认为01
      certificateNumber: microQuoteForm['holdType'] === 'G' ? formData['enterprise']['groupCertificateNo'] : formData['policy_holder_idNo'], // 投保人证件号码
    },
    sendDetail: express, // 发票相关信息
  };

  if (isTeamAccidentProd) {
    // 保险期限
    saveTemParams['applyPeriod']['term'] = (applyPeriod || {})['term'];
    saveTemParams['applyPeriod']['termUnit'] = (applyPeriod || {})['termUnit'];
    saveTemParams['effectDate']['beginDate'] = (effectDate || {})['beginDate'];
    saveTemParams['effectDate']['endDate'] = (effectDate || {})['endDate'];
  } else if (globalData['productCode'] === "P060090") {
    saveTemParams['applyPeriod']['term'] = 1;
    saveTemParams['applyPeriod']['termUnit'] = "M";
  }

  return axios.request({
    method: 'POST',
    url: BASE_HOST + '/pa18shopnst/do/era/save/saveTempApplyInfo?flowId=' + globalData['flowId'],
    data: saveTemParams,
  });
};

// 调用接口获取投保人信息
export const getSaveApplyInfo = () => axios.request({
  method: 'get',
  url: BASE_HOST + '/pa18shopnst/do/era/save/saveApplyInfo?flowId=' + globalData['flowId'],
});

// 小微亚马逊获取产品类型
export const getAmazonProductType = () => axios.request({
  method: 'get',
  url: BASE_HOST + '/pa18shopnst/do/micro/getProductTypeData',
});

// 小微亚马逊上传质量认证
export const uploadLicenseImg = (param) => axios.request({
  method: 'post',
  data: param,
  url: BASE_HOST + '/pa18shopnst/do/micro/uploadFileList',
});

// 根据场所类型查询标的信息
export const getTargetInfoByPlaceType = (param) => axios.request({
  method: 'post',
  data: param,
  url: BASE_HOST + '/pa18shopnst/do/mciro/commonen/queryRisksByLocationType',
});

// 获取职业类型接口（22版还是12版）
export const getProcessionType = () => axios.request({
  method: 'get',
  url: BASE_HOST + '/pa18shopnst/do/get/micProfessionFlag?productCode=' + globalData['productCode'],
});

// 获取强制阅读开关
export const getTeamFcClauses = () => axios.request({
  method: 'get',
  url: BASE_HOST + '/pa18shopnst/do/isOpen/teamFcClauses?productCode=' + globalData['productCode'],
});

// 获取生僻字开关
export const getSpzRareWord = () => axios.request({
  method: 'get',
  url: BASE_HOST + '/pa18shopnst/do/isOpen/rareWord',
});

// 获取生僻字tid及token
export const getSpzRareWordToken = () => axios.request({
  method: 'get',
  url: BASE_HOST + '/pa18shopnst/do/get/rareWordToken',
});

/**
 * 电商保获取用户唯一标识（applyNso 解密）
 * params {object} 参数
*/
export const getAliCompanyInfo = (params: any) => axios.request({
  method: 'post',
  data: {
    applyNo: params.applyNo || '',
    flowId: globalData['flowId'],
  },
  url: BASE_HOST + '/pa18shopnst/do/ali88/getAliCompanyInfo',
});

/**
 * 电商保获取用户5要素
 * params {object} 参数
*/
export const resolveApplyNo = (params: any) => axios.request({
  method: 'post',
  data: {
    applyNo: params.applyNo || '',
    sign: params.sign || '',
    aliCallback: params.aliCallback || '',
    timestamp: params.timestamp,
    flowId: params.flowId || '',
    user: params.user || '',
    tracelog: params.tracelog || ''
  },
  url: BASE_HOST + '/pa18shopnst/do/ali88/forwardToHtml',
});
